import { useRouter } from 'next/router'
import { VFC } from 'react'
import { ClockIcon, ListIcon, PenIcon } from 'src/assets/svgs'
import { TooltipWrapper } from 'src/components/Tooltip'
import { Link, LinkProps } from 'src/elements/Link'
import {
  _contributionmenubuttongradient,
  _contributionsidebarshadow,
  _contributiontext,
  truewhite,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { onLandscape } from 'src/styles/mixins'
import {
  CONTRIBUTIONS,
  CONTRIBUTIONS_NEW,
  MY_CONTRIBUTIONS,
  extractPathname,
} from 'src/utils/routes'
import styled, { css } from 'styled-components'

export const SIDE_ICON_MENU_WIDTH = '108px'

type SideIconMenuProps = {
  isSalesDemoPlan: boolean
}

export const SideIconMenu: VFC<SideIconMenuProps> = ({ isSalesDemoPlan }) => (
  <Layout>
    <div>
      <SideIconMenuLink href={CONTRIBUTIONS} Icon={ListIcon} label="投稿一覧" />
      {!isSalesDemoPlan && (
        <>
          <SideIconMenuLink
            href={CONTRIBUTIONS_NEW}
            Icon={PenIcon}
            label="投稿を作成"
          />
          <SideIconMenuLink
            href={MY_CONTRIBUTIONS}
            Icon={ClockIcon}
            label="過去投稿の管理"
          />
        </>
      )}
    </div>
  </Layout>
)

const Layout = styled.aside`
  width: ${SIDE_ICON_MENU_WIDTH};
  padding: 20px;
  background-color: ${truewhite};
  z-index: 1;
  > * {
    margin: 20px 0;
  }
  ${onLandscape(css`
    box-shadow: ${_contributionsidebarshadow};
  `)}
`

const SideIconMenuLink: VFC<
  Omit<LinkProps, 'children'> & { Icon: SvgrComponent; label: string }
> = ({ Icon, label, ...props }) => {
  const { asPath } = useRouter()
  return (
    <TooltipWrapper
      direction={{ y: 'top' }}
      xValue={'70px'}
      yValue={'10px'}
      tooltipNode={<LabelDiv>{label}</LabelDiv>}
    >
      <StyledLink isCurrent={extractPathname(asPath) === props.href} {...props}>
        <Icon />
      </StyledLink>
    </TooltipWrapper>
  )
}
const StyledLink = styled(Link)<{ isCurrent: boolean }>`
  display: flex;
  align-items: center;
  margin: 8px;
  padding: 15px;
  border-radius: 10px;
  font-weight: ${fontWeightBold};
  svg {
    width: 22px;
  }

  transition: color 0.2s ease-in-out;
  ${({ isCurrent }) =>
    isCurrent
      ? css`
          color: ${truewhite};
          background: ${_contributionmenubuttongradient};
        `
      : css`
          :hover {
            color: ${_contributiontext};
            background: #f6f6f6;
          }
        `}
`

const LabelDiv = styled.div`
  writing-mode: horizontal-tb;
`
